import React from "react";
import { PageHeader } from "./PageHeader";

export const Contact = props => {
  return (
    <React.Fragment>
      <PageHeader title="Kontakt" />
      <div className="content-wrapper">
        <div className="main-content contact">
          <div>
            <h2>Kontakt e-mail</h2>
            Sprawy organizacyjne: <a href="mailto:45zfp@uj.edu.pl">45zfp@uj.edu.pl</a>
                <br />
            Sprawy programowe: <a href="mailto:45zfp.program@uj.edu.pl">45zfp.program@uj.edu.pl</a>
                <br />
            Sprawy Konferencji Dydaktycznej: <a href="mailto:45zfp.dydaktyka@uj.edu.pl">45zfp.dydaktyka@uj.edu.pl</a>
            </div>
          <div>
            <h2>Adres korespondencyjny</h2>
            <div>
              <b> 45 Zjazd Fizyków Polskich</b>
              <br />
              <b>Instytut Fizyki im. M. Smoluchowskiego </b>
              <br />
              <b> Uniwersytet Jagielloński w Krakowie</b>
              <br />
              ul. Prof. St. Łojasiewicza 11,
                    <br />
              30-348 Kraków
                </div>
          </div>

        </div>
        <div className="main-content contact-people">
          <div>
            <div className="title">
              Przewodniczący Komitetu Organizacyjnego
                </div>
            <div className="bold-name">Dr hab. Roman Skibiński</div>
          </div>
          <div>
            <div className="title">
              Sekretarz Naukowy Komitetu Organizacyjnego
                </div>
            <div className="bold-name">Dr inż. Marcin Zieliński</div>
          </div>
          <div>
            <div className="title">
              Skarbnik Zjazdu
            </div>
            <div className="bold-name">Dr Danuta Goc-Jagło</div>
          </div>
        </div>
        <iframe title="map" className="contact-map" frameBorder="0" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJWWaMAYZcFkcRCdhUX4jUpYA&key=AIzaSyCEfTi5EjQOVcZopf0iiXiENp63NhdReGA"
          allowFullScreen></iframe>
      </div>
    </React.Fragment>
  );
};

Contact.propTypes = {};